import gql from "graphql-tag";

export const cartProductFields = gql`
  fragment CartProductFields on Product {
    id
    productCode
    name
    preOrder
    accessories {
      id
      name
      accessoryAmount
      imageLinks
    }
    cashPrices {
      basic {
        price
        currency {
          symbol
          code
        }
      }
      dealer {
        price
        currency {
          symbol
        }
      }
      promotion {
        price
      }
    }
    cashlessPrices {
      basic {
        price
        currency {
          symbol
          code
        }
      }
      dealer {
        price
        currency {
          symbol
        }
      }
      promotion {
        price
      }
    }
    promotion {
      type
      value
    }
    categories {
      id
      description
    }
    imageLinks
  }
`;

export const cartItemFields = gql`
  fragment CartItemFields on CartItem {
    quantity
    isEarlyBird
    packCount
    reservationType
    measureRatio
    amount {
      value
      currency {
        symbol
      }
    }
    promotion {
      type
      value
    }
    product {
      ...CartProductFields
    }
  }
  ${cartProductFields}
`;

export const cartSupplyGroupFields = gql`
  fragment CartSupplyGroupFields on CartSupplyGroup {
    supply {
      id
      receiptDate
      storage {
        name
      }
    }
    items {
      ...CartItemFields
    }
  }
  ${cartItemFields}
`;
